import styled from 'styled-components/macro'
import { theme } from 'styles/theme'
import { Slide as SlideBase, Image as ImageBase } from '../styled'
import { Button as ButtonBase } from '../../styled'

export const Slide = styled(SlideBase)`
  overflow: hidden;
  background: radial-gradient(50% 50% at 50% 50%, #ffe000 0%, #ff9c00 100%);

  &::before {
    content: none;
  }
`

export const Image = styled(ImageBase)`
  top: -1rem;
  left: -1rem;
  width: calc(100% + 2rem);
  height: calc(100% + 2rem);
  transition: all 0.6s;

  .swiper-slide:not(.swiper-slide-active) & {
    filter: blur(10px);
    opacity: 0.3;
  }
`

export const Button = styled(ButtonBase)`
  margin-top: 0.4em;
  padding-inline: 1.8em;
  transition: all 0.4s;
  border: 1px solid currentColor;

  &:hover,
  &:focus-visible {
    border-color: transparent;
    background-color: ${theme.colors.accent.primary};
  }
`
